import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ButtonWithIcon } from '@zoopla/blueprint-button-with-icon';
import {
    BinOutlineSmall,
    EmailOutlineSmall,
    ShareiosSmall,
    ShareSmall
} from '@blueprint/icons';

export const MobileOptionsButton = styled(ButtonWithIcon)(
    ({ theme: { focusRing, spacing } }) => css`
        display: block;
        position: absolute;
        right: 0;
        top: 0;

        &:focus {
            box-shadow: inset ${focusRing};
            outline: 0;
        }

        svg {
            height: ${spacing['16px']};
            width: ${spacing['16px']};
        }
    `
);

export const EmailOutlineSmallColored = styled(EmailOutlineSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['purple-bright']};
    `
);

export const BinOutlineColored = styled(BinOutlineSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['crimson']};
    `
);

export const ShareSmallColored = styled(ShareSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['purple-bright']};
    `
);

export const ShareiosSmallColored = styled(ShareiosSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['purple-bright']};
    `
);
